import {store, persistor} from './store';
import {resetOrders} from './ordersSlice';
import {catalogApi} from './catalogApi';
import {clearAuthSession} from '../utils/authSession';

export const logoutCleanup = () => {
	clearAuthSession();
	store.dispatch(resetOrders());
	store.dispatch(catalogApi.util.resetApiState());
	persistor.purge();
};
